<nibras-dialog [title]="data.title">
  <ng-container nibras-dialog-content>
    <div class="data-message">
      <span [innerHTML]="data.message"></span>
    </div>
  </ng-container>

  <ng-container nibras-dialog-footer>
    <div class="dialog-footer">
      <div>
        <mat-checkbox
          *ngIf="data.rememberKey"
          (change)="rememberThis = !rememberThis"
          class="small-size small-font"
          >{{ data.rememberKey }}</mat-checkbox
        >
      </div>
      <div class="btn-group">
        <button
        *ngIf="data.rememberKey"
          mat-flat-button
          class="nibras-button-secondary"
          (click)="neverAskAgain()"
        >
          Never Ask Again
        </button>
        <button mat-flat-button class="nibras-button-secondary" (click)="cancel()">
          {{ data.type === 'confirm' ? data.cancelButton || 'No' : data.closeButton || 'Ok' }}
        </button>
        <button
          mat-flat-button
          class="nibras-button-primary"
          *ngIf="data.type === 'confirm'"
          color="primary"
          (click)="confirm()"
        >
          {{ data.acceptButton || 'Yes' }}
        </button>
      </div>
    </div>
  </ng-container>
</nibras-dialog>
